module.exports = __webpack_public_path__ + "static/img/huaishuImg1.1b508d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/huaishuImg1.png
// module id = 1ZlX
// module chunks = 0